<template>
  <div class="alpha">
<!--    <div class="section-alpha-1">-->
<!--      <p class="section-header-1">Choose an <span style="color: #007aff">Investment</span> Plan</p>-->
<!--      <p class="section-header">You don't have an account yet? start trading with NextTrade Pro.</p>-->
<!--    </div>-->

<!--    <div class="section-alpha">-->

<!--      <div class="third-section top">-->
<!--        <p class="text-1">Silver</p>-->
<!--        <p class="text-2">5<span class="text-2-inner">% Bonus</span></p>-->
<!--        &lt;!&ndash;        <p class="text-2">4 Months</p>&ndash;&gt;-->
<!--        <p class="text-3">4 Months</p>-->

<!--        <div class="btn" @click="onPostClick" >-->
<!--          <p>Invest Now</p>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>$5,000 MINIMUM DEPOSIT</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>ENHANCED SECURITY</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>1.2% DAILY</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>GUARANTEED ROI</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>24/7 SUPPORT</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="third-section top">-->
<!--        <p class="text-1">Gold</p>-->
<!--        <p class="text-2">10<span class="text-2-inner">% Bonus</span></p>-->
<!--        &lt;!&ndash;        <p class="text-2">4 Months</p>&ndash;&gt;-->
<!--        <p class="text-3">8 Months</p>-->

<!--        <div class="btn" @click="onPostClick" >-->
<!--          <p>Invest Now</p>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>$25,000 MINIMUM DEPOSIT</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>ENHANCED SECURITY</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>1.4% DAILY</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>GUARANTEED ROI</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>24/7 SUPPORT</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="third-section top">-->
<!--        <p class="text-1">Diamond</p>-->
<!--        <p class="text-2">15<span class="text-2-inner">% Bonus</span></p>-->
<!--        &lt;!&ndash;        <p class="text-2">4 Months</p>&ndash;&gt;-->
<!--        <p class="text-3">12 Months</p>-->

<!--        <div class="btn" @click="onPostClick" >-->
<!--          <p>Invest Now</p>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>$100,000 MINIMUM DEPOSIT</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>ENHANCED SECURITY</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>1.6% DAILY</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>GUARANTEED ROI</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>24/7 SUPPORT</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="third-section top">-->
<!--        <p class="text-1">Platinum</p>-->
<!--        <p class="text-2">20<span class="text-2-inner">% Bonus</span></p>-->
<!--        &lt;!&ndash;        <p class="text-2">4 Months</p>&ndash;&gt;-->
<!--        <p class="text-3">24 Months</p>-->

<!--        <div class="btn" @click="onPostClick" >-->
<!--          <p>Invest Now</p>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>$250,000 MINIMUM DEPOSIT</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>ENHANCED SECURITY</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>1.8% DAILY</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>GUARANTEED ROI</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->

<!--        <div class="separate">-->
<!--          <p>24/7 SUPPORT</p>-->
<!--          <i class='bx bxs-info-circle'></i>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->

    <div class="section-1">

      <p class="header">General FAQs</p>

      <section>
        <details>
          <summary style="color: #FFFFFF;">
            WHAT IS TOPSHARES PRO
          </summary>
          <p>
            TopShares Pro is an officially registered company and conducts
            business under the laws of the UK Government. The company is involved
            in Stocks, Option , CFD, Forex , Crypto Bonds and Real Estate. Also trading other valuable
            commodities/assets which we offer to our clients to earn from using a
            single trading account.
          </p>
        </details>
        <details>
          <summary style="color: #FFFFFF;">
            HOW SAFE ARE MY INVESTMENTS IN YOUR COMPANY
          </summary>
          <p>
            It is absolutely safe because all our technical experts are extremely
            experienced professionals; our Stocks, Option , CFD, Forex , Crypto Bonds and Real Estate sourcing and
            other investment strategies are proven to work.
          </p>
        </details>

<!--        <details>-->
<!--          <summary style="color: #FFFFFF;">-->
<!--            HOW CAN I MAKE SURE YOUR COMPANY IS A REAL AND NOT A FAKE ONE-->
<!--          </summary>-->
<!--          <p>-->
<!--            NextTrade Pro is officially incorporated with the UK-->
<!--            Companies Office. verify registration: (click here)-->
<!--&lt;!&ndash;            <a href="https://find-and-update.company-information.service.gov.uk/company/10477019">&ndash;&gt;-->
<!--&lt;!&ndash;              https://find-and-update.company-information.service.gov.uk/company/10477019&ndash;&gt;-->
<!--&lt;!&ndash;            </a>&ndash;&gt;-->
<!--          </p>-->
<!--        </details>-->
        <details>
          <summary style="color: #FFFFFF;">
            CAN I LOOSE MONEY IF I INVEST NOW?
          </summary>
          <p>
            In accordance to investment laws of the FCA with over £3Billion
            investment security, we never worry about those rainy days in global
            trades and projects as we have our investors covered
          </p>
        </details>

        <details>
          <summary style="color: #FFFFFF;">
            DO YOU PROVIDE PROOF OF YOUR TRADING  ACTIVITIES
          </summary>
          <p>
            No, at the moment this is a closed information, but in the future we
            plan to publish our trade reports regularly. We will announce further,
            follow our news.
          </p>
        </details>

        <details>
          <summary style="color: #FFFFFF;">
            What security types are available?
          </summary>
          <p >TopShares Pro accounts offer several security types to verify the identity of the account owner and protect
            sensitive information. These security types include phone, email, and TOTP
            (available only in certain countries). Each account action requires a six-digit code, sent to the chosen
            security type, to be entered for confirmation. Only one security type can be active at a time, but changes
            can be made under certain conditions. Additionally, a unique alphanumeric Support PIN is generated to act
            as the highest level of security. This PIN is used to verify the account owner when contacting support,
            ensuring that sensitive information is accessible only to the true account owner.</p>
        </details>


      </section>

    </div>

    <div class="section-1">

      <p class="header">Deposit and Withdrawal FAQ'S</p>

      <section>
        <details>
          <summary style="color: #FFFFFF;">
            What are instant deposits and withdrawals?
          </summary>
          <p>
            he term “instant” indicates that a transaction will be carried out within a few seconds without manual
            processing by our financial department specialists. Please note that although it's instantly processed
            on our side, your deposit or withdrawal requests may take some time to be processed on the payment
            system provider's side.
          </p>
        </details>
        <details>
          <summary style="color: #FFFFFF;">
            How long do TopShares Pro withdrawals take via bank card?
          </summary>
          <p>
            On TopShares Pro' side all withdrawal requests are processed instantly. Your withdrawal request is then sent to
            our card processors and your bank, and the whole process can take from 1 to 30 business days for the funds
            to be reflected in your bank account depending on the bank and country you are located in.
          </p>
        </details>

        <details>
          <summary style="color: #FFFFFF;">
            Can I withdraw funds to an account that is not my own?
          </summary>
          <p>
            Funds can be withdrawn to your own personal accounts only. This is a safeguard put in place to ensure
            financial security.
          </p>
        </details>
        <details>
          <summary style="color: #FFFFFF;">
            What payment accounts can I use to deposit and withdraw?
          </summary>
          <p>
            You must use your own personal payment accounts for deposits and withdrawals. We will not accept direct
            payments or payments to or from third parties. All the information you need regarding transactions
            can be found in your Personal Area. If your deposit payment method is unavailable during withdrawal,
            contact the Support tea. Occasionally, some payment systems may be turned off due to maintenance.
          </p>
        </details>

        <details>
          <summary style="color: #FFFFFF;">
            When can I deposit and withdraw?
          </summary>
          <p>
            Deposits and withdrawals can be executed 24/7. If a deposit or withdrawal is not instant, we will process
            it within 24 hours. Bear in mind, it may take your bank or payment service a little longer. We can’t be
            held liable for any deposit or withdrawal processing delays that are caused by payment systems. We reserve
            the right to change the processing time for deposits and withdrawals without prior notification.
          </p>
        </details>

      </section>

    </div>

    <br/>
    <br/>


  </div>
</template>

<script>
export default {
  name: "HomeSection4",
  methods: {
    onPostClick() {
      this.$router.push("/register");
      window.scrollTo(0, 0);
    },
  },
}
</script>

<style scoped>
.alpha{
  height: 100%;
  padding-bottom: 5%;
  padding-top: 5%;
}
.section-header{
  font-size: 18px;
  text-align: center;
  color: #8599a6;
  margin-bottom: 3%;
}
.section-header-1{
  font-weight: 700;
  font-size: 40px;
  line-height: 58px;
  color: #FFFFFF;
  padding-bottom: 10px;
  text-align: center;
}
.section-alpha{
  display: flex;
  justify-content: space-evenly;
  margin-right: 3%;
  margin-left: 3%;
}

.section-alpha-2{
  display: flex;
  justify-content: space-evenly;
}

.section-alpha-1{
  display: block;
  text-align: center;
  margin-bottom: 2%;
}

.third-section{
  width: 300px;
  height: 480px;
  background-color: hsla(0, 0%, 4%, .9);
  border: 1px solid hsla(0, 0%, 4%, .9);
  /*box-shadow:  5px 5px 5px #d9d9d9,*/
  /*-5px -5px 5px #d9d9d9;*/
  border-radius: 12px;
  margin-bottom: 5%;
}

.separate{
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 1%;
}

.separate i{
  padding-top: 15px;
  padding-right: 13px;
}

.separate p{
  width: 220px;
  padding-top: 15px;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  padding-left: 13px;
}

.btn{
  margin-top: 5%;
  margin-bottom: 1%;
}

.btn p{
  display: block;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  padding: 12px 20px;
  gap: 8px;
  width: 180px;
  height: 44px;
  background: #007aff;
  border: 1px solid #007aff;
  color: #ffffff;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}



.top{
  margin-top: 1%;
}

.text-1{
  text-align: center;
  padding-top: 9%;
  padding-bottom: 3%;
  font-size: 19px;
  color: #FFFFFF;
}

.text-2{
  text-align: center;
  padding-bottom: 4%;
  font-size: 27px;
  font-weight: bold;
  color: #FFFFFF;
}

.text-2-inner{
  font-size: 14px;
  font-weight: normal;
  color: #FFFFFF;
}

.text-3{
  text-align: center;
  font-size: 16px;
  width: 70%;
  display: block;
  margin-right: auto;
  margin-left: auto;
  color: #FFFFFF;
}


.bx{
  color: #ffffff;
}

.section-1{
  padding-top: 4%;
  display: flex;
  justify-content: space-evenly;
  /*align-content: center;*/
  /*align-items: center;*/
}
.header{
  font-stretch: normal;
  font-style: normal;
  font-weight: 900;
  letter-spacing: normal;
  font-size: 23px;
  line-height: 1.26;
  margin: 0;
  color: #ffffff;
  width: 25%;
}
.lawrence{
  padding-left: 5%;
}
.lawrence li{
  padding-bottom: 2px;
}
section {
  width: 42%;
  /*margin: auto;*/
}

details[open] summary ~ * {
  animation: open 0.4s ease-in;
}


summary{
  color: #FFFFFF;
}

p{
  color: #8599a6;
}

@keyframes open {
  0% {
    transform: translateY(-60px);
    opacity: 0;
  }
  50% {
    transform: translateY(0);
    opacity: 1;
  }
  60% {
    transform: translateX(10px);
  }
  70% {
    transform: translateX(-10px);
  }
  80% {
    transform: translateX(5px);
  }
  90% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
details summary::-webkit-details-marker {
  display: none;
}

details summary {
  width: 100%;
  position: relative;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 900;
  list-style: none;
  /*padding-top: 18px;*/
  /*padding-bottom: 10px;*/
  text-transform: uppercase;
  color: #222222;
}

details summary:after {
  content: "+";
  color: #8599a6;
  position: absolute;
  font-size: 1.7rem;
  line-height: 0;
  margin-top: 0.75rem;
  right: 0;
  font-weight: bold;
  transform-origin: center;
  transition: 200ms linear;
}
details[open] summary:after {
  transform: rotate(45deg);
  font-size: 2rem;
}
details summary {
  outline: 0;
}
details p {
  font-size: 16px;
  margin: 0 0 1rem;
  padding-top: 1rem;
  line-height: 1.5;
}
details {
  /*box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);*/
  position: relative;
  padding: 15px;
  margin-bottom: 2%;
  /*border-radius: 5px;*/
  border-bottom: solid 0.125rem #8599a6;
}
@media (max-width: 990px) {

}

@media (max-width: 700px) {
  .section-1{
    display: block;
    width: 100%;
  }
  .header{
    width: 100%;
    text-align: center;
  }
  .details summary {
    font-size: 20px;
  }
  details p {
    font-size: 16px;
    margin: 0 0 1rem;
    padding-top: 1rem;
  }
  summary{
    font-size: 20px;
  }
  section {
    width: 82%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .section-alpha{
    display: block;
    /*margin-left: 21%;*/
    margin-top: 3.5%;
  }
  .section-alpha-2{
    display: block;
    /*margin-left: 21%;*/
    margin-top: 3.5%;
  }
  .third-section{
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .section-header-1{
    font-size: 25px;
  }

  .section-header{
    margin-left: 3%;
    margin-right: 3%;
  }
}

@media (max-width: 500px) {
}

</style>